import React from "react";
import { Button, Label } from "reactstrap";
import styles from "./Button.scss";
import { CircularProgress } from "../CircularProgress/CircularProgress";

const GenericButton = ({
  label,
  handleClick,
  icon,
  marginRightIcon,
  iconSvg,
  rounded,
  primary,
  secondary,
  pl0,
  backgroundColor,
  marginLeft,
  textColor,
  grayDark,
  border,
  fontWeight,
  lineHeight,
  padding,
  position,
  bottom,
  width,
  right,
  style,
  className,
  labelStyle,
  loading,
  disabled,
}) => {
  return (
    <div
      style={{ width: width || "fit-content", position: position, bottom: bottom }}
      className={`${right && styles.reverse}`}
    >
      <Button
        style={{
          marginLeft: marginLeft,
          backgroundColor: backgroundColor,
          color: textColor,
          border: border,
          fontWeight: fontWeight,
          lineHeight: lineHeight,
          padding: padding,
          width: "100%",
          ...style,
        }}
        className={`${styles.btnGeneric} ${rounded && styles.roundedMd} ${
          pl0 ? styles.pl0 : styles.pNormal
        }  ${secondary && styles.normal} ${primary && styles.activeButton} ${
          grayDark && styles.grayDark
        } ${className}`}
        onClick={handleClick}
        disabled={loading || disabled}
      >
        {icon && <i className={`${icon} `}></i>}
        {iconSvg &&
          iconSvg.map((icon, index) => {
            return (
              <img
                key={"buttonIcon" + index}
                style={{ height: "20px", width: icon.width }}
                src={icon.item}
              ></img>
            );
          })}
        <Label style={{ marginRight: marginRightIcon, ...labelStyle }}>{label}</Label>
        {loading && <CircularProgress sm style={{ margin: 0 }} />}
      </Button>
    </div>
  );
};
export default GenericButton;
